export default class SalaryCutsActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_SALARYCUTS='GET_HELPER_SALARYCUTS';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: SalaryCutsActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: SalaryCutsActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: SalaryCutsActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: SalaryCutsActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: SalaryCutsActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: SalaryCutsActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: SalaryCutsActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: SalaryCutsActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: SalaryCutsActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: SalaryCutsActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: SalaryCutsActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: SalaryCutsActions.GET_HELPER_SALARYCUTS,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: SalaryCutsActions.ERROR_SERVER,
      payload: error
    };
  }
}